import { createReducer } from '@reduxjs/toolkit';
import { type GooglePayStore } from '../../types/StoreState';
import { getGooglePayOptions } from '../../actions/googlePay/getGooglePayOptions';

export const googlePayOptionsInitialState: GooglePayStore['options'] = {
  data: {
    isSandbox: undefined,
  },
  loading: 'idle' as const,
};

export const googlePayOptionsReducer = createReducer(googlePayOptionsInitialState, (builder) => {
  builder
    .addCase(getGooglePayOptions.pending, (state) => {
      state.loading = 'pending';
    })
    .addCase(getGooglePayOptions.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = 'fulfilled';
    })
    .addCase(getGooglePayOptions.rejected, (state) => {
      state.loading = 'rejected';
    });
});
